export default __webpack_public_path__ + "static/media/alert-x-white-home.7eea0bce.svg";